import { useState, useEffect } from 'react';
import { useUser } from '@foundation/contextapi/UserContext';
import { supabase } from '@foundation/utils/supabaseClient';

type OrgAdminStatus = {
  isOrgAdmin: boolean;
  isLoading: boolean;
};

export const useOrgAdmin = (): OrgAdminStatus => {
  const { user } = useUser();
  const [isOrgAdmin, setIsOrgAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!user?.id) {
        setIsOrgAdmin(false);
        setIsLoading(false);
        return;
      }

      try {
        const { data } = await supabase
          .schema('altzero')
          .from('base_profiles')
          .select('role')
          .eq('id', user.id)
          .single();

        const role = (data as { role?: string } | null)?.role ?? '';
        setIsOrgAdmin(role === 'admin' || role === 'org_admin');
      } catch {
        setIsOrgAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    check();
  }, [user?.id]);

  return { isOrgAdmin, isLoading };
};
